export class StripeError extends Error {
  constructor(message) {
    super(message);
  }
}

